import axios from 'axios'
import join from 'url-join'

import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import '../vendor/libs/sweetalert2/sweetalert2.scss'

const apibase = process.env.REACT_APP_API_BASE_URL
const apikey = process.env.REACT_APP_APP_KEY
/*
const publicKey = process.env.REACT_APP_PUBLIC_KEY;
const encryptor = new JSEncrypt();
encryptor.setPublicKey(publicKey);
const maxLength = ((encryptor.getKey().n.bitLength() + 7) >> 3) - 11;

function encryptAndVerify(reqVal){
    let encrypted;
    console.log("jsonReqStr >> "+reqVal)
    //console.log("maxLength >> "+maxLength)
    if(reqVal.length < maxLength){
        encrypted = encryptor.encrypt(reqVal);
    } else {
        encrypted = reqVal
    }
    //console.log(encrypted)
    if (encrypted != null) return encrypted;
    else return null;
}
 */
const ReactSwal = withReactContent(
  Swal.mixin({
    buttonsStyling: false,
    customClass: {
      confirmButton: 'btn btn-info btn-lg',
      cancelButton: 'btn btn-default btn-lg',
      actions: 'text-center',
    },
  }),
)

axios.interceptors.request.use(async config => {
  /*
    console.log(config.url)
    console.log(config.method)
    if(config.method === 'get'){
        let encrypt;
        if(config.params){ // From GET Methode
            console.log("config.params")
            console.log(config.params)
            let jsonReqStr = JSON.stringify(config.params)
            encrypt = encryptAndVerify(jsonReqStr);
            config.params = btoa(encrypt);
        } else if(config.data && config.data.params){ // From GET Methode
            console.log("config.data.params")
            console.log(config.data.params) 
            let jsonReqStr = JSON.stringify(config.data.params)
            encrypt = encryptAndVerify(jsonReqStr);
            config.params = btoa(encrypt);
        }
        console.log(config.params) 
    }
    if(config.method === 'post'){
        if(config.data.params){
            console.log("config.data.params")
            let encrypt;
            let jsonReqStr = JSON.stringify(config.data.params)
            encrypt = encryptAndVerify(jsonReqStr);
            config.data = {data : btoa(encrypt)};
        } else if(config.data){
            console.log("config.data")
            let encrypt;
            let jsonReqStr = JSON.stringify(config.data)
            encrypt = encryptAndVerify(jsonReqStr);
            config.data = {data : btoa(encrypt)};
        }
        console.log(config.data)
    }
    */
  const accesstoken = localStorage.getItem('accesstoken')
  // console.log('accesstoken ' +accesstoken);
  // console.log('process.env.APP_KEY is '+process.env.APP_KEY)
  // const user = localStorage.getItem('user');
  // const appkey = localStorage.getItem('app-key');
  //const renewtoken = localStorage.getItem('accesstoken');
  // console.log('user is '+user);
  if (accesstoken) {
    // let userObject = JSON.parse(user);
    // let accesstoken = userObject.accesstoken;
    config.headers = {
      'Content-Type': 'application/json',
      'x-access-token': accesstoken,
      'app-key': apikey,
      // 'app-key': process.env.APP_KEY
    }
  } else {
    config.headers = {
      'Content-Type': 'application/json',
      'app-key': apikey,
      // 'app-key': process.env.APP_KEY//'5TTTwVNjJ1YYocQEpCG1nfXmCXIhFcr0'
    }
  }

  config.url = join(apibase, config.url)
  config.validateStatus = status => {
    return true // I'm always returning true, you may want to do it depending on the status received
    // if(status == 401){
    //     return false;
    // }else{
    //     return true;
    // }
  }
  //request timeout in ms
  if (!config.timeout) {
    config.timeout = 1000 * 60
  }

  return config
})

// Add a response interceptor
axios.interceptors.response.use(
  function (response) {
    let respMessage = ''
    let respCode = ''
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data

    if (response.status === 500 || response.status === 502) {

        //ถ้ามี data กลับมาจาก service ให้หน้าจอแสดง message เอง
      if (!response.data || !response?.data?.data) {
        // if (_.has(response, 'data')) {
        //     respMessage = _.get(response, 'data.message')
        //     respCode = _.get(response, 'data.code')

        //     if (userErrorMsg.indexOf(respMessage) !== -1|| respCode.includes("user_pw_incorrect")) {
        //         respMessage = 'Username or Password incorrect.'
        //         console.log('respMessage', respMessage)
        //     }
        // }
        console.error('ERROR_500')
        ReactSwal.fire({
          title: 'ไม่สามารถเชื่อมต่อกับ server ได้',
          // text: 'Please contact administrator.',
          text: response.statusText,
          // footer: (<a href="#d" onClick={this.prevent}>Why do I have this issue?</a>)
        })

        return Promise.reject(response)
      } else if (response.data && response.data.message === 'Invalid renew token') {
        console.error('ERROR_AUTHEN')
        // ReactSwal.fire({ //REQUIREMENT UAT 20240421.
        //   title: 'หมดเวลาเข้าใช้งาน',
        //   text: 'กรุณา Login เข้าใช้งานใหม่อีกครั้ง',
        // }).then(result => {
        //forward to login
        window.location.href = process.env.REACT_APP_LOGIN_ROUTE
        //  })
      } else {
        return response
      }
      //Promise.reject(response);
      //Promise.reject(response);
      //throw new Error(response);
    } else if ([400, 404].includes(response.status)) {
      return Promise.reject(response)
    } else if (response.status === 401 && response.data.code === 'expired') {
      const originalRequest = response.config
      // console.log('original request', response.config)
      if (!originalRequest._retry) {
        originalRequest._retry = true
        let originalUrl = originalRequest.url
        let newUrl = originalUrl.replace(apibase, '')
        originalRequest.url = newUrl
        const renewaccesstoken = localStorage.getItem('renewtoken')

        return new Promise(async (resolve, reject) => {
          return await renewtoken(renewaccesstoken)
            .then(newtoken => {
              // console.log('new token is ', newtoken)
              if (newtoken) {
                resolve(apiClient(originalRequest))
              } else {
                reject(response)
              }
            })
            .catch(e => {
              // console.log('error', e)
              //force logout
              localStorage.removeItem('accesstoken')
              localStorage.removeItem('renewtoken')
              localStorage.removeItem('user')
              localStorage.removeItem('userinfo')

              // ReactSwal.fire({   //REQUIREMENT UAT 20240421.
              //   title: 'หมดเวลาเข้าใช้งาน',
              //   text: 'กรุณา Login เข้าใช้งานใหม่อีกครั้ง',
              // }).then(result => {
              window.location.href = process.env.REACT_APP_LOGIN_ROUTE
              //})

              // return reject(response)
            })
        })
      }
    } else if (response.status === 401 && response.data.code === 'invalid') {
      ReactSwal.fire({
        title: 'หมดเวลาเข้าใช้งาน',
        text: 'กรุณา Login เข้าใช้งานใหม่อีกครั้ง',
      }).then(result => {
        window.location.href = process.env.REACT_APP_LOGIN_ROUTE
      })
    } else if (response.status === 401) {
      console.error('ERROR_TOKEN_VERIFY')
    } else {
      // console.log('STATUS', response.status)
      return response
    }
  },
  function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    // console.log(JSON.stringify(error));
    // console.log(error.name)
    // console.log(error.message)
    // console.log('error from api ', error)

    if (error.code === 'ECONNABORTED' || error.name === 'Error' || error.message === 'Network Error') {
      // console.log('5555555')
      ReactSwal.fire({
        title: 'ไม่สามารถเชื่อมต่อระบบได้',
        //text: 'Please check your internet connection and try again.',
        text: 'กรุณาตรวจสอบการเชื่อมต่ออินเตอร์เน็ตและลองใหม่อีกครั้ง',
        // footer: (<a href="#d" onClick={this.prevent}>Why do I have this issue?</a>)
      })

      console.error('ERROR_ECONNABORTED')
      return Promise.reject(error)
    } else {
      ReactSwal.fire({
        title: 'ไม่สามารถเชื่อมต่อระบบได้',
        // text: 'Please check your internet connection and try again.',
        text: 'กรุณาตรวจสอบการเชื่อมต่ออินเตอร์เน็ตและลองใหม่อีกครั้ง',
        // footer: (<a href="#d" onClick={this.prevent}>Why do I have this issue?</a>)
      })

      console.error('ERROR_NETWORK')
      return Promise.reject(error)
    }
  },
)

export const renewtoken = async (token, history) => {
  let response = await apiClient.post(process.env.REACT_APP_PHASE2_PATH_PREFIX + '/user-login/renew', {
    renewtoken: token,
  })

  localStorage.setItem('accesstoken', response.data.accesstoken)

  return response.data.accesstoken
}

export const apiClient = axios
